import { Icon } from "@circle-react-shared/Icon";

import { t } from "@/i18n-js/instance";

interface ResetButtonProps {
  onClick: () => void;
  variant?: "default" | "dark" | "light";
}

export const ResetButton = ({
  onClick,
  variant = "default",
}: ResetButtonProps) => {
  const baseClasses =
    "text-sm flex items-center justify-center gap-2 rounded-full border px-3.5 py-1.5 font-semibold";
  const variantClasses =
    variant === "light"
      ? "border-white bg-white text-gray-900 hover:bg-gray-100"
      : variant === "dark"
        ? "border-[#2b2e33] bg-[#2b2e33] text-[#f7f9fa] hover:border-[#3a3d42] hover:bg-[#3a3d42]"
        : "bg-primary text-darkest border-primary hover:bg-circle-button hover:text-circle-button";

  return (
    <button
      type="button"
      className={`${baseClasses} ${variantClasses}`}
      onClick={onClick}
    >
      <Icon type="20-reload" size={20} />
      {t("community_inbox.reset_preview")}
    </button>
  );
};
